import { Factory } from 'rosie';
import moment from 'moment';

import '../conversation_item_factory';

// This is for demo use only

Factory.define('Narvar').attr('type', 'NARVAR');
Factory.define('NarvarWithDefaults')
  .extend('Narvar')
  .attr('leftLabel', 'Delivery Date')
  .attr(
    'leftContent',
    moment()
      .add(2, 'days')
      .format('dddd, MMM DD')
  )
  .attr('rightLabel', 'Shipment Status')
  .attr('rightContent', 'Out for Delivery')
  .attr('url', 'www.google.com')
  .attr('urlLabel', 'Track Package');

Factory.define('NarvarItem')
  .extend('ConversationItem')
  .attr('_demoOnly', true)
  .attr('content', ['content'], function(content) {
    return Factory.attributes('Narvar', content);
  });

Factory.define('NarvarItemWithDefaults')
  .extend('ConversationItemWithDefaults')
  .attr('_demoOnly', true)
  .attr('content', ['content'], function(content) {
    return Factory.attributes('NarvarWithDefaults', content);
  });
